<template>
	<div class="pages">
		<div class="goback" @click="goBack"></div>
		<div class="userBack" @click="$router.push({ name: 'my' })"></div>
		<div class="titleBG"><img src="@/static/images/my/officeImg.png" alt="" /></div>

		<div class="details">
			<div class="details-info">
				<div class="details-info-title">已报名 99/100人</div>
				<div class="details-info-avatarList flex flex-align-center flex-jus-between flex-wrap">
					<div class="details-info-avatarList-avatar flex flex-column" v-for="item in 100" :key="item">
						<img src="@/static/images/my/avatar.png" alt="">
						<div>张大大</div>
					</div>
				</div>
			</div>

		</div>


	</div>
</template>

<script>
/* eslint-disable */
export default {
	data() {
		return {

		};
	},
	created() {},
	mounted() {
	},
	methods: {
		goBack() {
			if (window.history.length <=1 ) {
				this.$router.push('/home')
			} else {
				this.$router.back(-1)
			}
		}
	}
};
</script>




<style scoped lang="stylus">

.pages
	min-height 100vh
	background-color #F6F6F6
	overflow-y auto
	padding-bottom 120px
.titleBG
	width 100%
	height 400px
.goback
	position fixed
	left 30px
	top 24px
	width 52px
	height 52px
	background-image url('~@/static/images/icon-arrowLeft.png')
	background-size 100% 100%
	background-position center
	z-index 10
.userBack
	position fixed
	right 30px
	top 24px
	width 52px
	height 52px
	background-image url('~@/static/images/icon-my.png')
	background-size 100% 100%
	background-position center
	z-index 10
	
.details
	padding 0 30px
	.details-info
		padding 40px 26px
		margin-top -44px
		background-color #FFFFFF
		border-radius 20px
		position relative
		.details-info-title
			width 100%
			font-size: 34px;
			font-weight: bold;
			color: #0A0A0A;
			text-align center
			margin-bottom 42px
		.details-info-avatarList
			.details-info-avatarList-avatar
				margin-bottom 42px
				margin-right 50px
				font-size: 26px;
				font-weight: 500;
				color: #000000;
				&:nth-child(5n)
					margin-right 0 !important
				img
					width: 84px;
					height: 84px;
					background: rgba(0, 0, 0, 0);
					border-radius: 42px;
					margin-bottom 16px
</style>
